import * as types from '../actions/types';

const initialState = {
  gradebook: {},
  semesterGrades: [],
  isLoading: false,
  downloadLoading: false,
};

export default function credits(state = initialState, action) {
  switch (action.type) {
    case types.CREDITS_FETCH_COMPLETED:
      return {
        ...state,
        gradebook: action.gradebook,
        isLoading: false,
      };
    case types.SEMESTER_GRADE_CREDITS_FETCH_COMPLETED:
      return {
        ...state,
        semesterGrades: action.semesterGrades,
        isLoading: false,
      };
    case types.CREDITS_FETCH_STARTED:
      return {
        ...state,
        isLoading: true,
      };
    case types.SET_CREDITS_LOADING:
      return {
        ...state,
        downloadLoading: action.payload,
      };
    default:
      return state;
  }
}
